module.exports = __webpack_public_path__ + "media/images/logo_pwn_pdf-9d7a52b9bc3bb3e0c691d082a9def245.png";